import { render } from "./AppPaymentForm.vue?vue&type=template&id=2f548704&scoped=true&lang=pug"
import script from "./AppPaymentForm.vue?vue&type=script&lang=js"
export * from "./AppPaymentForm.vue?vue&type=script&lang=js"

import "./AppPaymentForm.vue?vue&type=style&index=0&id=2f548704&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f548704"]])

export default __exports__